export default "__VITE_ASSET__D_IC7kSO__"